/**
 * @desc 查询供应商sku报价审批修改数据
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(
  params: API.srm.supplierQuotation.getDetailByInstanceId.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/srm/supplierQuotation/getProcessBusinessDataByInstanceId`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
